<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Disputed Lead Policy
      </content-page-title>
    </template>
    <div class="pa-2 white rounded-lg">
      <Dispute />
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'
import Dispute from '@/components/documents/Dispute_2023_03_30'

export default {
  name: 'LegalDisputePolicy',

  components: { ContentPage, ContentPageTitle, Dispute},
}
</script>